<div nxRow="">
  <div nxCol="12,12,12,6">
    <div nxRow="">
      <div nxCol="12">
        <nx-formfield label="{{'user.roles' | caption}} *">
          <nx-multi-select [(ngModel)]="user.roles" name="roles" (selectionChange)="setDefaultChmod()"
            [options]="staticRoles"
            [selectDisabled]="roleSelectDisabled()"
          ></nx-multi-select>
        </nx-formfield>
      </div>
      @if (user.roles.includes('Partner') && partners && userPartner) {
        <div nxCol="12">
          <nx-formfield label="{{'user.partners' | caption}}">
            <nx-multi-select [(ngModel)]="userPartner" name="partners"
              [options]="partners"
              [filter]="true"
              selectLabel="name"
              selectValue="id"
              (selectionChange)="changeUserPartner()"
            ></nx-multi-select>
          </nx-formfield>
        </div>
      }
      @if (user.roles.includes('distributor') && distributors && userDistributor) {
        <div nxCol="12">
          <nx-formfield label="{{'user.distributor' | caption}}">
            <nx-multi-select [(ngModel)]="userDistributor" name="distributors"
              [options]="distributors"
              [filter]="true"
              selectLabel="name"
              selectValue="id"
              (selectionChange)="changeUserDistributor()"
              [selectDisabled]="distributorSelectDisabled()"
            ></nx-multi-select>
          </nx-formfield>
        </div>
      }
    </div>
  </div>
  <div nxCol="12,12,12,6">
    <div nxRow="">
      <div nxCol="12">
        @for (role of user.roles; track role) {
          <nx-radio-group [(ngModel)]="user.chmod[roleIndex[role]]" [name]="'chmod'+role" [disabled]="roleEditDisabled(role)">
            <nx-label>{{role}} {{'user.role' | caption}}</nx-label>
            <div class="horizontal-checkboxes">
              <nx-radio nxValue="4" class="nx-margin-bottom-s">
                {{'general.read' | caption}}
              </nx-radio>
              <nx-radio nxValue="6" class="nx-margin-bottom-s">
                {{'general.readAndWrite' | caption}}
              </nx-radio>
            </div>
          </nx-radio-group>
        }
      </div>
    </div>
  </div>
</div>
